function ManualStep({ number, title, children, variant = 'default' }) {
  return (
    <div className={`manual-step manual-step-${variant}`}>
      <div className="manual-step-number">
        <span>{number}</span>
      </div>
      <div className="manual-step-content">
        {title && <h4 className="manual-step-title">{title}</h4>}
        <div className="manual-step-text">{children}</div>
      </div>
    </div>
  );
}

export default ManualStep;
